(function ($, Drupal, drupalSettings, once) {

  /**
   * Manually redirect searches to search page and persist query string
   *
   * @type {{attach: attach}}
   */
  Drupal.behaviors.searchSite = {
    attach: function attach(context, settings) {
      const searchButton = '.js-search-submit';
      const searchInput = '.js-search-input';
      const keyword = 'keyword';
      const queryId = '.query-keyword';
      const results = '.results';
      const noResults = '.no-results';
      const searchButtonId = '#edit-submit-solr-search';
      let basePath = drupalSettings.path.baseUrl === '/' ? drupalSettings.path.baseUrl : drupalSettings.path.baseUrl + '/';
      if (drupalSettings.path.pathPrefix !== '') {
        basePath = basePath + drupalSettings.path.pathPrefix
      }

      if (this.getUrlParameterByName(keyword)) {
        $(queryId).text(this.getUrlParameterByName(keyword));
        $(results).css('display', 'inline-block');
      } else {
        $(noResults).css('display', 'inline-block');
      }

      $(once('.js-search-submit',searchButton)).each(function () {
        $(this).on('click', (event) => {
          event.preventDefault();
          if ($(searchInput).val() !== '') {
            window.location = basePath + 'search?keyword=' + $(searchInput).val()
          }
        });
      });

      if ($(window).width() <= 667) {
        $(searchButtonId).contents().filter(function () {
          return this.nodeType === 3;
        }).remove()
      }

      // On enter submit search form in nav
      $(document).keypress(function (e) {
        if (e.which === 13) {
          if ($(searchInput).is(':focus') && $(searchInput).val() !== '') {
            window.location = basePath + 'search?keyword=' + $(searchInput).val()
          }
        }
      });

      $('.navbar-search .dropdown-toggle').click(function (event) {
        event.preventDefault();
      })

      Drupal.behaviors.svgConvert.convert();

    },
    getUrlParameterByName: function (name, url) {
      if (!url) {
        url = window.location.href;
      }
      name = name.replace(/[\[\]]/g, '\\$&');
      const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`);
      const results = regex.exec(url);
      if (!results || !results[2]) {
        return null;
      }
      return decodeURIComponent(results[2].replace(/\+/g, ' '));
    },
  };

})(jQuery, Drupal, drupalSettings, once);
